// extracted by mini-css-extract-plugin
module.exports = {"msg":"styles_msg__XeffT"};